import { render, staticRenderFns } from "./SmOwTextLink.vue?vue&type=template&id=4dddd7fe&scoped=true&"
import script from "./SmOwTextLink.vue?vue&type=script&lang=ts&"
export * from "./SmOwTextLink.vue?vue&type=script&lang=ts&"
import style0 from "./SmOwTextLink.vue?vue&type=style&index=0&id=4dddd7fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dddd7fe",
  null
  
)

export default component.exports